"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailDTO = void 0;
class EmailDTO {
    to;
    subject;
    content;
}
exports.EmailDTO = EmailDTO;
